import Builder from './class-builder';

class EconPlusBuilder extends Builder {

  /*
  * Render path for desktop
  */
  getRenderPathDesktop() {
    return this.renderDomain + 'econo-plus-spiral/desktop/';
  }

  /*
  * Render path for mobile
  */
  getRenderPathMobile() {
    return this.renderDomain + 'econo-plus-spiral/mobile/';
  }

  /*
  * Create image SKU
  */
  getRenderImage() {
    return 'SV' + this.getWidthImage(this.selection_data.width) + '09' + this.getFinishImage(this.selection_data.finish) + this.getTreadTypeImage(this.selection_data.tread_type) + this.getTreadCoverImage(this.selection_data.tread_cover) + 'A' + this.getNumberOfPlatformRailsImage(this.selection_data.number_of_platform_rails);
  }

  /*
  * Match width SKU
  */
  getWidthImage(width) {
    switch (width) {
      case '36':
      case '50':
        return width;
      default:
        return '36';
    }
  }

  /*
  * Match finish SKU
  */
  getFinishImage(finish) {
    switch (finish) {
      case 'B':
      case 'C':
      case 'N':
        return finish;
      default:
        return 'B';
    }
  }

  /*
  * Match tread type SKU
  */
  getTreadTypeImage(tread_type) {
    switch (tread_type) {
      case 'S':
      case 'R':
        return tread_type;
      default:
        return 'S';
    }
  }

  /*
  * Match tread cover SKU
  */
  getTreadCoverImage(tread_cover) {
    switch (tread_cover) {
      case 'N':
      case 'C':
        return tread_cover;
      default:
        return 'N';
    }
  }

  /*
  * Match number of platform rails SKU
  */
  getNumberOfPlatformRailsImage(number_of_platform_rails) {
    switch (number_of_platform_rails) {
      case '1':
      case '2':
        return number_of_platform_rails;
      default:
        return '1';
    }
  }

  /*
  * Create sku from object
  * The order of the sku matches the spreadsheet from Mary
  */
  setSku() {
    this.sku = this.selection_data.product_line + this.selection_data.width + this.selection_data.height + this.selection_data.finish + this.selection_data.tread_type + this.selection_data.tread_cover + this.selection_data.handrail + this.selection_data.number_of_platform_rails;
  }

  /*
  * Create object from sku
  * The order of the sku matches the spreadsheet from Mary
  */
  getSkuObject(sku) {
    var product_line,
        width,
        height,
        tread_type,
        tread_cover,
        handrail,
        number_of_platform_rails,
        finish,
        selection_data = {};

    if (sku) {
      product_line = sku.substring(0, 2);
      width = sku.substring(2, 4);
      height = sku.substring(4, 6);
      finish = sku.substring(6, 7);
      tread_type = sku.substring(7, 8);
      tread_cover = sku.substring(8, 9);
      handrail = sku.substring(9, 10);
      number_of_platform_rails = sku.substring(10, 11);

      selection_data = {
        'product_line' : product_line,
        'width' : width,
        'height' : height,
        'finish' : finish,
        'tread_type' : tread_type,
        'tread_cover' : tread_cover,
        'handrail' : handrail,
        'number_of_platform_rails' : number_of_platform_rails,
      }
    }

    this.selection_data = selection_data;
    return selection_data;
  }
}

export default EconPlusBuilder;
